/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
*/
// Import PolymerElement class
import { PolymerElement, html } from "../../@polymer/polymer/polymer-element.js";
import { mixinBehaviors } from "../../@polymer/polymer/lib/legacy/class.js"; // define the element's class element

class employerDetails extends mixinBehaviors([sbBehaviours.currencyFormatorBehaviour, corpBehaviours.appCommonBehaviour, sbBehaviours.authAndSubmit], PolymerElement) {
  static get template() {
    return html`
         
          <style  include="app-styles">    


          .buttonParent{
            position: relative;
          }
          .buttonHeight{
             /* position: absolute;
             bottom: 13%;
             right: 9%; */
           position: relative;
           /* margin-top: 85%; removed under defect 413726*/
          }

          .buttonPosition{
            position: absolute;
            align-content: center;
            bottom: 0;
            padding-bottom: 3%;
          }
         </style>
         
		<app-media-query tablet={{tablet}} phone={{phone}} desktop={{desktop}}></app-media-query>
		
        
        <!-- App Dialog -->
         <!-- <oe-ajax auto id="employerNameFetch" url="/api/codereferences?filter[where][codeType]=EMPN&filter[order]=codeDescription" on-response="employerNameResponse" on-error="adressListError"></oe-ajax> -->
         <oe-ajax auto id="employerNameFetch" url="/api/codereferences?filter[where][codeType]=ENAM&filter[order]=codeDescription" on-response="employerNameResponse" on-error="adressListError"></oe-ajax>

        
        <app-dialog id="backNagigationPopup" closevisible="{{closevisible}}" elementid="backNagigationPopup">
            <div class="mdl-grid">
                <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet">
                    <oe-i18n-msg msgid="m_backNavigationError" class="font-size-m"></oe-i18n-msg>
                </div>
                <div class="mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet ">
                    <paper-button id="submitEmployerDetailsFormSubmit" on-tap="_leftAction" on-keypress="_leftAction" class="flat-button">
                        <oe-i18n-msg id="employment-details-update-okButton" class="text-brand-color" msgid="b_Yes"></oe-i18n-msg>
                    </paper-button>
                    <paper-button id="submitEmployerDetailsFormSubmit" on-tap="_cancelBack" on-keypress="_cancelBack" class="flat-button">
                        <oe-i18n-msg id="employment-details-update-cancelButton" class="text-brand-color" msgid="b_No"></oe-i18n-msg>
                    </paper-button>
                </div>
            </div>
      </app-dialog>
      <!--Header Part -->
        <div class="mdl-grid  mdl-grid--no-spacing" hidden$={{phone}} hidden$={{desktop}}>
                <div class="mdl-cell mdl-cell--1-col-phone mdl-cell--2-col-tablet mdl-cell--3-col" >
                    <div hidden$="{{displayIcon(leftAction.leftIcon)}}"> </div>
                    <a href="{{leftAction.lefthref}}" tabIndex="-1" hidden$="{{leftAction.leftCallback}}" >
                        <paper-icon-button icon="{{leftAction.leftIcon}}" class="action-btn-rtl"></paper-icon-button>
                    </a>
                    <div hidden$="{{!leftAction.leftCallback}}">
                        <paper-icon-button aria-label$="{{backButtonString}}" id="primary_account_back_button" icon="{{leftAction.leftIcon}}" on-tap="_backNavigation"  class="action-btn-rtl"></paper-icon-button>
                    </div>
                </div>
                <div tabindex="0" role="heading" aria-level="2" class="outlineOffset mdl-cell mdl-cell--2-col-phone mdl-cell--4-col-tablet mdl-cell--6-col content-align-center text-align-center title-dark">
                  <oe-i18n-msg msgid="{{headerTitle}}" id="employer_details_title"></oe-i18n-msg>
                </div>
        </div>

        <div class="buttonParent mdl-grid">
				  <div class="margin-b-zero margin-t-zero mdl-cell mdl-cell--12-col mdl-cell--4-col-phone mdl-cell--8-col-tablet">
          <div>
        <!--  <oe-combo role="combobox" id="employment_status" label="l_EmployementStatus" valueproperty="cmCode" value="{{employementStatus}}"
              displayproperty="codeDescription" listdata="{{employmentStatusList}}" >
            </oe-combo>-->
            <oe-combo role="combobox" id="natureofemployment" label="l_natureofemployment" required validate-on-input user-error-message="l_nature_of_employment_status" displayproperty="codeDescription"
                                    scroll-action="cancel" value="{{employmentType}}" valueproperty="cmCode" listdata="{{natureOfEmploymentData}}">
            </oe-combo>
          </div>                
               <!-- <template is="dom-if" if="{{!showAllField}}">
                      <template is="dom-if" if="{{showIndustryType}}">
                        <div>
                        <oe-combo role="combobox" id="employer_industryType" label="l_IndustryType" valueproperty="cmCode" value="{{industryType}}"
                              displayproperty="codeDescription" listdata="{{industryTypeList}}">
                          </oe-combo>
                        </div>                          
                      </template>
                      <template is="dom-if" if="{{!showIndustryType}}">
                          
                          <oe-combo role="combobox" id="employerdetails_employername" label="l_EmployerName" valueproperty="cmCode" value="{{employerName}}"
                            displayproperty="codeDescription" listdata="{{employerNameList}}" >
                          </oe-combo>
                          <div>
                            <oe-combo role="combobox" id="employer_OccupationType" label="l_OccupationType" valueproperty="cmCode" value="{{occupationType}}"
                                    displayproperty="codeDescription" listdata="{{occupationList}}">
                            </oe-combo>
                          </div>                          
                       </template>
                        <oe-date  id="employmentDate" label="{{labelShow}}" 
                        format="{{dateFormat}}"  max="{{maxDate}}" locale="[[locale]]" value="{{employmentStartDate}}"></oe-date>
                    </template>-->
                    <template is="dom-if" if="{{showSalariedTypeFields}}" restamp=true>
                                <div class="full-width">
                                    <oe-combo id="jobType" label="l_employmentStatus" required validate-on-input user-error-message="l_employment_status" displayproperty="codeDescription"
                                        scroll-action="cancel" value="{{jobType}}" valueproperty="cmCode" listdata="{{jobTypeList}}">
                                    </oe-combo>
                                </div>
                                <div class="full-width">
                                    <oe-combo id="empNameInp" label="l_EmployerName" validate-on-input  user-error-message="l_enterEmployerName" displayproperty="codeDescription"
                                        scroll-action="cancel" value="{{employerCode}}" valueproperty="cmCode" listdata="{{employerNameList}}">
                                    </oe-combo>
                                </div>
                                <div class="full-width">
                                    <oe-combo id="empPosition" label="l_employeePosition" validate-on-input  user-error-message="m_enter_employeePosition" displayproperty="codeDescription"
                                        scroll-action="cancel" value="{{occupationType}}" valueproperty="cmCode" listdata="{{employeePositionList}}">
                                    </oe-combo>
                                </div>
                                <div class="full-width">
                                  <oe-date  id="employmentStDate" label="l_EmployementStartDate" format="{{dateFormat}}"  max="today" locale="[[locale]]" value="{{employedFrom}}">
                                  </oe-date>
                                </div>
                            </template>
                            <template is="dom-if" if="{{showMilitaryTypeFields}}" restamp=true>
                                <div class="full-width"> 
                                    <oe-combo id="empPosition_military" label="l_employeeJobPosition" validate-on-input  user-error-message="m_enterEmployeePosition" displayproperty="codeDescription"
                                        scroll-action="cancel" value="{{occupationType}}" valueproperty="cmCode" listdata="{{employeePositionList}}">
                                    </oe-combo>
                                </div>
                                <div class="full-width"> 
                                    <oe-date  id="employmentStartDate_military" label="l_EmployementStartDate" 
                                      format="{{dateFormat}}"  max="today" locale="[[locale]]" value="{{employedFrom}}">
                                     </oe-date>       
                                </div>
                            </template>
                            <template is="dom-if" if="{{showSelfEmployedTypeFields}}" restamp=true>
                                <!--<div class="full-width">
                                    <oe-combo id="mainApplicant_empIndustry" label="l_industry" validate-on-input  user-error-message="m_enter_employeeIndustry" displayproperty="codeDescription"
                                        scroll-action="cancel" value="{{mainApplicant.employeeIndustry}}" valueproperty="cmCode" listdata="{{employeeIndustryList}}">
                                    </oe-combo>
                                </div>-->
                                <div class="full-width"> 
                                  <oe-input id="businessName" label="l_BusinessName" validate-on-input maxlength="50"  user-error-message="m_enterBusinessName" value="{{businessName}}"></oe-input>
                                </div>
                                <div class="full-width"> 
                                    <oe-date  id="employmentStartDate_selfEmployed" label="l_EmployementStartDate" 
                                      format="{{dateFormat}}"  max="today" locale="[[locale]]" value="{{employedFrom}}">
                                     </oe-date>       
                                </div>
                    </template>
                </div>
            </div>
            <template is="dom-if" if="{{!phone}}">
                <div class="mdl-grid buttonHeight">
                    <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col text-align-center">
                      <paper-button class="primary-button" id="employer-details-update" on-keydown="setFocus" on-tap="_updateEmployerDetails" on-keypress="_updateEmployerDetails">
                            <oe-i18n-msg msgid="b_Update"></oe-i18n-msg>
                      </paper-button>
                    </div>
                </div>
           </template>

           <template is="dom-if" if="{{phone}}">
                <div class="mdl-grid">
                    <div class="buttonPosition mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col text-align-center">
                      <paper-button class="primary-button" id="employer-details-update" on-tap="_updateEmployerDetails" on-keypress="_updateEmployerDetails">
                            <oe-i18n-msg msgid="b_Update"></oe-i18n-msg>
                      </paper-button>
                    </div>
                </div>
           </template>


           


            <!-- app dialog for authorization i.e. transaction  password -->
            <app-dialog name="h_Authorization" id="employerDetailsUpdateAuthorization" elementid="employerDetailsUpdateAuthorization">
              <div class="mdl-grid">
                  <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet">
                    <fin-auth-element-wrapper id="employer_details_form_authPaymentStopWrapper" auth-method="{{authMethods}}"></fin-auth-element-wrapper>
                  </div>
                  <div class="mdl-cell--4-col-phone mdl-cell--12-col-desktop  mdl-cell--8-col-tablet ">
                    <paper-button id="submitEmployerDetialsFormAuthsubmit" on-tap="_continueToConfirm" on-keypress="_continueToConfirm" class="flat-button">
                      <oe-i18n-msg id="submitEmployerDetialsFormAuthsubmitLabel" class="text-brand-color" msgid="b_Submit"></oe-i18n-msg>
                    </paper-button>
                  </div>
              </div>
            </app-dialog>
          `;
  }

  static get properties() {
    return {
    // to set aria-label for back button
      backButtonString: {
        type: String,
        notify: true,
        value: getLabel('b_Back')
      },
	/**to store date format */
      dateFormat: {
        type: String,
        notify: true
      },
       /**to store employers details for update mode */
      employersDetails: {
        type: Object,
        notify: true,
        observer: "_employersDetailsObserver"
      },
      employerName: {
        type: String,
        notify: true
      },
      closevisible: {
        type: Boolean,
        value: false
      },
      /**employment status list dropdown list */
      employmentStatusList: {
        type: Array,
        notify: true
      },employerNameList: {
        type: Array,
        notify: true
      },
      /**industry type list for dropdown list */
      industryTypeList: {
        type: Array,
        notify: true
      },
       /**Occupation type list for dropdown list */
      occupationList: {
        type: Array,
        notify: true
      },
      /**to store employment status */
      employementStatus: {
        type: String,
        notify: true,
      },
      employmentType: {
        type: String,
        notify: true,
        observer: '_employmentStatusChangeObserver'
      },
      /**to store industry type */
      industryType: {
        type: String,
        notify: true
      },
        /**to store occupation type */
      occupationType: {
        type: String,
        notify: true
      },
        /**to store employment date */
      employmentStartDate: {
        type: Date,
        notify: true
      },
      myprofilepagenumber: {
        type: Number,
        notify: true
      },
        /**to hide and show industry type dropdwon */
      showIndustryType: {
        type: Boolean,
        notify: false
      },
        /**to show employment date and start date label*/
      labelShow: {
        type: String,
        notify: true
      },
        /**to hide and show industry type,occupation type,date & employer name */
      showAllField: {
        type: Boolean,
        value: false,
        notify: true
      },
      //To store authentication methods
      authMethods: {
        type: Array,
        notify: true
      },
      //to store header title of page
      headerTitle: {
        type: String,
        notify: true
      },
      employedFrom: {
        type: Date,
        notify: true
      },

      //for grouping NOT_Employed List
      notEmployedStatusList: {
        type: Array,
        value: []
        // value: ["Home_Duties", "Non_Specified", "Not_Employed", "Retired", "Student"]
      },
      // for grouping salaried Employed list 
      salariedStatusList: {
        type: Array,
        value: ['SALARIED']
      },
      //for grouping Self_Employed list
      selfEmployedStatusList: {
        type: Array,
        value: ['SELF EMPLOYED']
      },
      militaryEmployedList: {
        type: Array,
        value: ['MILITARY']
      },

      updateEmployFlag: {
        type: Boolean,
        notify:true,
        value: false
      },
      jobType: {
        type: String,
        notify: true
      },
      jobTypeList: {
        type: Array,
        notify: true
      },
      employeePositionList: {
        type: Array,
        notify: true
      },
      employerCode: {
        type: String,
        notify: true
      },
      position: {
        type: String,
        notify: true
      },
      occupationType: {
        type: String,
        notify: true
      },
      employedFrom: {
        type: String,
        notify: true
      },
      businessName: {
        type: String,
        notify: true
      },
      showSalariedTypeFields: {
        type: Boolean,
        notify: true
      },
      showMilitaryTypeFields: {
        type: Boolean,
        notify: true
      },
      showSelfEmployedTypeFields: {
        type: Boolean,
        notify: true
      },
      natureOfEmployment: {
        type: Object,
        notify: true,
      }
    };
  }

  connectedCallback() {
    super.connectedCallback();
  }

  _employersDetailsObserver() {
    if (Object.keys(this.employersDetails).length) {
      //this.resteFormValues();
      if (this.employersDetails.hasOwnProperty('operationMode') && this.employersDetails['operationMode'] != "") {
        this.getNatureOfEmploymentList();
        this.getEmploymentStatusList();
        // this.getIndustryTypeList();
        // this.getOccupationList();
        this.getEmployerNameList();
        this.getPositionList();
        this.bindPropertyValues(this.employersDetails);
      }
    }
  } // back button on tap


  _backNavigation() {
    this.authMethods = [];
    if (this.phone && $('.mainContent') !== undefined) {
      $('#index_HeaderPanel')[0].children[1].style.removeProperty('margin-top');
      $('.mainContent')[0].style.removeProperty('margin-bottom');
      $('#index_HeaderPanel')[0].children[1].classList.add('page-container-min-height');
  }
    if (this._isDataChange()) {
      this.$.backNagigationPopup.$$("#backNagigationPopup").open();
    } else {
      this.myprofilepagenumber = 0;
    }
  }

  _isDataChange() {
    if (this.employersDetails) {
      if (this.employmentType && this.selfEmployedStatusList.indexOf(this.natureOfEmployment) != -1) {
        if (this.employersDetails.hasOwnProperty("natureOfEmployment") && this.employersDetails.natureOfEmployment.cmCode == this.employmentType) {
          return false;

        } else if (this.employersDetails.hasOwnProperty("businessName") && this.employersDetails.businessName.cmCode == this.businessName) {
          return false;
        }
        else {
          return true;
        }
      }
      else if (this.employmentType && this.militaryEmployedList.indexOf(this.natureOfEmployment) != -1) {
        if (this.employersDetails.hasOwnProperty("natureOfEmployment") && this.employersDetails.natureOfEmployment.cmCode == this.employmentType) {
          return false;
        } else if (this.employersDetails.hasOwnProperty("occupation") && this.employersDetails.occupation.cmCode == this.occupationType) {
          return false;
        } else {
          return true;
        }
      }
      else if (this.employmentType && this.salariedStatusList.indexOf(this.natureOfEmployment) != -1) {
        if (this.employersDetails.hasOwnProperty("natureOfEmployment") && this.employersDetails.natureOfEmployment.cmCode == this.employmentType) {
          return false;

        } else if (this.employersDetails.hasOwnProperty("occupation") && this.employersDetails.occupation.cmCode == this.occupationType) {
          return false;
        } else if (this.employersDetails.hasOwnProperty("employerName") && this.employersDetails.employerName == this.employerCode) {
          return false;

        } else if (this.employersDetails.hasOwnProperty("employementStatus") && this.employersDetails.employementStatus.cmCode == this.jobType) {
          return false;
        } else {
          return true;
        }
      }
      else {
        return false;
      }
    }
  } // cancel button on tap


  _cancelBack() {
    this.$.backNagigationPopup.$$("#backNagigationPopup").close();
  } //To navigate back


  _leftAction() {
    this.resteFormValues();
    this.$.backNagigationPopup.$$("#backNagigationPopup").close();
    this.myprofilepagenumber = 0;
  } //To display the back icon


  displayIcon(value) {
    if (value == "") return true;
    return false;
  }

  resteFormValues() {
    // if (this.$$("#employment_status") != null) {
    //   this.$$("#employment_status").invalid = false;
    if (this.$$("#natureofemployment") != null) {
      this.$$("#natureofemployment").invalid = false;
    }

    if (this.$$("#jobType") != null) {
      this.$$("#jobType").value = undefined;
      this.$$("#jobType").invalid = false;
    }

    if (this.$$("#empNameInp") != null) {
      this.$$("#empNameInp").value = undefined;
      this.$$("#empNameInp").invalid = false;
    }

    if (this.$$("#empPosition") != null) {
      this.$$("#empPosition").value = undefined;
      this.$$("#empPosition").invalid = false;
    }

    if (this.$$('#employmentStDate') != null) {
      this.$$('#employmentStDate').value = new Date();
      this.$$('#employmentStDate').invalid = false;
    }
    if (this.$$("#empPosition_military") != null) {
      this.$$("#empPosition_military").value = undefined;
      this.$$("#empPosition_military").invalid = false;
    }
    if (this.$$('#employmentStartDate_military') != null) {
      this.$$('#employmentStartDate_military').value = new Date();
      this.$$('#employmentStartDate_military').invalid = false;
    }
    if (this.$$("#businessName") != null) {
      this.$$("#businessName").value = undefined;
      this.$$("#businessName").invalid = false;
    }
    if (this.$$('#employmentStartDate_selfEmployed') != null) {
      this.$$('#employmentStartDate_selfEmployed').value = new Date();
      this.$$('#employmentStartDate_selfEmployed').invalid = false;
    }
  } // format date into UTC format


  _convertEmploymentDateInUTCFormat(unformatedDate) {
    if (unformatedDate != undefined) {
      var t = newOeDate(unformatedDate);
    } else {
      var t = newOeDate();
    }

    var formattedDate = getNewDate(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate()));
    return formattedDate;
  } // bind values for form in update mode 


  bindPropertyValues(employerDetails) {
    if (employerDetails) {
      if (employerDetails.operationMode == "UPDATE") {
        this.headerTitle = getLabel('h_UpdateEmployerDetails');
        this.employerCode = employerDetails.employerName.cmCode;
        this.dateFormat = clientStorage.get(storageType.session, 'dateFormat');
        this.maxDate = newOeDate();

        if ((this.salariedStatusList.indexOf(employerDetails.natureOfEmployment.cmCode) != -1) || (this.militaryEmployedList.indexOf(employerDetails.natureOfEmployment.cmCode) != -1) || (this.selfEmployedStatusList.indexOf(employerDetails.natureOfEmployment.cmCode) != -1)) {
          if (employerDetails.emplStartDate) {
            this.employedFrom = this._convertEmploymentDateInUTCFormat(employerDetails.emplStartDate);
          }
          else {
            this.employedFrom = this._convertEmploymentDateInUTCFormat();
          }
        } else {
          this.employedFrom = this._convertEmploymentDateInUTCFormat();
        }
      } else {
        this.headerTitle = getLabel('h_AddEmployerDetails');
        this.employmentType = undefined;
        this.dateFormat = clientStorage.get(storageType.session, 'dateFormat');
        this.maxDate = newOeDate();
        this.employedFrom = this._convertEmploymentDateInUTCFormat();
        this.showAllField = true;
      }
    }
  } //get employment status list for employment status combo


  getOccupationList() {
    var ajaxCall = document.createElement('oe-ajax');
    var self = this;
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json";
    ajaxCall.url = "/api/codereferences?filter[where][codeType]=OCCP&filter[order]=codeDescription";
    ajaxCall.method = 'get';
    ajaxCall.addEventListener('response', function (event) {
      self.set("occupationList", event.detail.response);

      //self._employmentStatusGrouping(this.employmentStatusList);

      // for  updating the occupation type
      if (self.employersDetails && self.employersDetails.hasOwnProperty('occupation')) {
        var occupationCode = [];
        occupationCode = self.occupationList.filter(occupation => {
          return occupation.cmCode == self.employersDetails.occupation.cmCode;
        });

        if (occupationCode.length) {
          self.set("occupationType", occupationCode[0].cmCode);
        } // end of occupationCode

      }

    });
    ajaxCall.addEventListener("error", function () {
      self.occupationList = [];
    });
    oeAjaxEventListner(ajaxCall);
    ajaxCall.generateRequest();
  } //get industry type list for industry combo box


  getIndustryTypeList() {
    var ajaxCall = document.createElement('oe-ajax');
    var self = this;
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json";
    ajaxCall.url = "/api/codereferences?filter[where][codeType]=HIDT&filter[order]=codeDescription";
    ajaxCall.method = 'get';
    ajaxCall.addEventListener('response', function (event) {
      self.set("industryTypeList", event.detail.response);

      if (self.employersDetails && self.employersDetails.hasOwnProperty("industryType")) {
        var industryCode = [];
        industryCode = self.industryTypeList.filter(industry => {
          return industry.cmCode == self.employersDetails.industryType.cmCode;
        });

        if (industryCode.length) {
          self.set("industryType", industryCode[0].cmCode);
        }
      }
    });
    ajaxCall.addEventListener("error", function () {
      self.industryTypeList = [];
    });
    oeAjaxEventListner(ajaxCall);
    ajaxCall.generateRequest();
  }


  getNatureOfEmploymentList() {
    var ajaxCall = document.createElement('oe-ajax');
    var self = this;
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json";
    ajaxCall.url = "api/CodeReferences?filter[where][codeType]=NOEM&filter[order]=codeDescription";
    ajaxCall.method = 'get';
    ajaxCall.addEventListener('response', function (event) {
      self.set("natureOfEmploymentData", event.detail.response);
      if (self.employersDetails && self.employersDetails.hasOwnProperty("natureOfEmployment")) {
        var employmentTypeCode = [];
        employmentTypeCode = self.natureOfEmploymentData.filter(employmentType => {
          return employmentType.cmCode == self.employersDetails.natureOfEmployment.cmCode;
        });
        if (employmentTypeCode.length) {
          self.set("employmentType", employmentTypeCode[0].cmCode);
        } // end of occupationCode
      }
    });
    ajaxCall.addEventListener("error", function () {
      self.natureOfEmploymentData = [];
    });
    oeAjaxEventListner(ajaxCall);
    ajaxCall.generateRequest();
  }
  getEmploymentStatusList() {
    var ajaxCall = document.createElement('oe-ajax');
    var self = this;
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json";
    ajaxCall.url = "/api/codereferences?filter[where][codeType]=EMPS&filter[order]=codeDescription";
    ajaxCall.method = 'get';
    ajaxCall.addEventListener('response', function (event) {
      self.set("jobTypeList", event.detail.response);
      if (self.employersDetails.operationMode == "UPDATE") {
        if (self.employersDetails && self.employersDetails.hasOwnProperty('employementStatus')) {
          var jobTypeCode = [];
          jobTypeCode = self.jobTypeList.filter(employee => {
            return employee.cmCode == self.employersDetails.employementStatus.cmCode;
          });
          if (jobTypeCode.length) {
            self.set("jobType", jobTypeCode[0].cmCode);
          } //end of employmentStatus
        }
      } else {
        this.jobType = "";
      }
    });
    ajaxCall.addEventListener("error", function () {
      self.jobTypeList = [];
    });
    oeAjaxEventListner(ajaxCall);
    ajaxCall.generateRequest();
  }
  //get occupation list for occupation combo box
  getPositionList() {
    var ajaxCall = document.createElement('oe-ajax');
    var self = this;
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json";
    ajaxCall.url = "/api/CodeReferences?filter[where][codeType]=DESG&filter[order]=codeDescription";
    ajaxCall.method = 'get';
    ajaxCall.addEventListener('response', function (event) {
      self.set("employeePositionList", event.detail.response);

      if (self.employersDetails && self.employersDetails.hasOwnProperty("occupation")) {
        var positionCode = [];
        positionCode = self.employeePositionList.filter(occupationType => {
          return occupationType.cmCode == self.employersDetails.occupation.cmCode;
        });

        if (positionCode.length) {
          self.set("occupationType", positionCode[0].cmCode);

        } // end of occupationCode

      }

    });
    ajaxCall.addEventListener("error", function () {
      self.employeePositionList = [];
    });
    oeAjaxEventListner(ajaxCall);
    ajaxCall.generateRequest();
  } //employment Status change observer


  _employmentStatusChangeObserver() {
    if (typeof this.employmentType == "string" && this.employmentType != "") {

      if (this.militaryEmployedList.indexOf(this.employmentType) != -1) {
        // this.showAllField = true;
        // this.industryType = undefined;
        this.showMilitaryTypeFields = true;
        this.showSelfEmployedTypeFields = false;
        this.showSalariedTypeFields = false;
        this.jobType = undefined;
        this.employerCode = undefined;
        this.businessName = undefined;
        this.occupationType = undefined;
        this.employedFrom = undefined;

        if (this.employeePositionList && this.employeePositionList.length) {
          if (this.employersDetails['natureOfEmployment'] && this.employersDetails['natureOfEmployment'].cmCode == this.employmentType) {
            if (this.employersDetails && this.employersDetails.hasOwnProperty("occupation")) {
              var positionCode = [];
              positionCode = this.employeePositionList.filter(position => {
                return position.cmCode == this.employersDetails.occupation.cmCode;
              });

              if (positionCode.length) {
                this.set("occupationType", positionCode[0].cmCode);
              } // end of occupationCode
            }
          }
        }
        if (this.employersDetails && this.employersDetails.hasOwnProperty('natureOfEmployment')) {
          if (this.employersDetails['natureOfEmployment'] && this.employersDetails['natureOfEmployment'].cmCode == this.employmentType) {
            this.employedFrom = this._convertEmploymentDateInUTCFormat(this.employersDetails['emplStartDate']);
          } else {
            this.employedFrom = this._convertEmploymentDateInUTCFormat();
          }
        }
      } else if (this.salariedStatusList.indexOf(this.employmentType) != -1) {
        // this.showAllField = false;
        // this.showIndustryType = false;
        // this.labelShow = getLabel('l_EmployementStartDate');
        // this.industryType = undefined;
        this.showSalariedTypeFields = true;
        this.showMilitaryTypeFields = false;
        this.showSelfEmployedTypeFields = false;
        this.jobType = undefined;
        this.employerCode = undefined;
        this.businessName = undefined;
        this.occupationType = undefined;
        this.employedFrom = undefined;
        if (this.employersDetails && this.employersDetails.hasOwnProperty('natureOfEmployment')) {
          if (this.employersDetails['natureOfEmployment'] && this.employersDetails['natureOfEmployment'].cmCode == this.employmentType) {
            this.employedFrom = this._convertEmploymentDateInUTCFormat(this.employersDetails['emplStartDate']);
          } else {
            this.employedFrom = this._convertEmploymentDateInUTCFormat();
          }
        }

        if (this.employeePositionList && this.employeePositionList.length) {
          if (this.employersDetails['natureOfEmployment'] && this.employersDetails['natureOfEmployment'].cmCode == this.employmentType) {
            if (this.employersDetails && this.employersDetails.hasOwnProperty("occupation")) {

              var positionCode = [];
              positionCode = this.employeePositionList.filter(occupationType => {
                return occupationType.cmCode == this.employersDetails.occupation.cmCode;
              });

              if (positionCode.length) {
                this.set("occupationType", positionCode[0].cmCode);
              } // end of occupationCode
            }
          }
        } // end of occupationList

        //prepoulated employer name set (Update Mode)
        if (this.jobTypeList && this.jobTypeList.length) {
          if (this.employersDetails && this.employersDetails.hasOwnProperty("employementStatus")) {
            var jobTypeCode = [];
            jobTypeCode = this.jobTypeList.filter(jobType => {
              return jobType.cmCode == this.employersDetails.employementStatus.cmCode;
            });
            if (jobTypeCode.length) {
              this.set("jobType", jobTypeCode[0].cmCode);
            } // end of occupationCode
          }
        }
        if (this.employerNameList && this.employerNameList.length) {
          if (this.employersDetails && this.employersDetails.hasOwnProperty("employerName")) {
            var employerCodeCode = [];
            employerCodeCode = this.employerNameList.filter(employerCode => {
              return employerCode.cmCode == this.employersDetails.employerName.cmCode;
            });
            if (employerCodeCode.length) {
              this.set("employerCode", employerCodeCode[0].cmCode);
            } // end of occupationCode
          }
        }

      } else if (this.selfEmployedStatusList.indexOf(this.employmentType) != -1) {
        // this.showIndustryType = true;
        // this.labelShow = getLabel('l_StartDate');
        // this.showAllField = false;
        this.showSelfEmployedTypeFields = true;
        this.showMilitaryTypeFields = false;
        this.showSalariedTypeFields = false;
        this.jobType = undefined;
        this.employerCode = undefined;
        this.businessName = undefined;
        this.occupationType = undefined;
        this.employedFrom = undefined;

        if (this.employersDetails && this.employersDetails.hasOwnProperty('natureOfEmployment')) {
          if (this.employersDetails['natureOfEmployment'] && this.employersDetails['natureOfEmployment'].cmCode == this.employmentType) {
            this.employedFrom = this._convertEmploymentDateInUTCFormat(this.employersDetails['emplStartDate']);
          } else {
            this.employedFrom = this._convertEmploymentDateInUTCFormat();
          }
        }

        if (this.employersDetails && this.employersDetails.hasOwnProperty("businessName")) {
          if (this.employersDetails['businessName']) {
            this.businessName = this.employersDetails['businessName'];

          }
        }

      } else {
        this.showMilitaryTypeFields = false;
        this.showSelfEmployedTypeFields = false;
        this.showSalariedTypeFields = false;
        this.jobType = undefined;
        this.employerCode = undefined;
        this.businessName = undefined;
        this.occupationType = undefined;
        this.employedFrom = undefined;
      }
    }
  } //validate the employer details form


  _validateEmployerDetailsForm() {
    if (this.showSalariedTypeFields) {
      if (!this.jobType) {
        this.fire('oe-show-error', {
          message: getLabel('l_employment_status')
        });
        this.$$("#jobType").invalid = true;
        return false;
      } else if (!this.employerCode) {
        this.fire('oe-show-error', {
          message: getLabel('l_enterEmployerName')
        });
        this.$$("#empNameInp").invalid = true;
        return false;
      } else if (!this.occupationType) {
        this.fire('oe-show-error', {
          message: getLabel('m_enter_employeePosition')
        });
        this.$$("#empPosition").invalid = true;
        return false;
      } else if (!this.employedFrom) {
        this.fire('oe-show-error', {
          message: getLabel('l_validateEmploymentDateErr')
        });
        this.$$("#employmentStDate").invalid = true;
        return false;
      } else {
        return true;
      }
    } else if (this.showMilitaryTypeFields) {
      if (!this.occupationType) {
        this.fire('oe-show-error', {
          message: getLabel('m_enterEmployeePosition')
        });
        this.$$("#empPosition_military").invalid = true;
        return false;
      } else if (!this.employedFrom) {
        this.fire('oe-show-error', {
          message: getLabel('l_validateEmploymentDateErr')
        });
        this.$$("#employmentStartDate_military").invalid = true;
        return false;
      } else {
        return true;
      }
    } else if (this.showSelfEmployedTypeFields) {
      if (!this.businessName) {
        this.fire('oe-show-error', {
          message: getLabel('m_enterBusinessName')
        });
        this.$$("#businessName").invalid = true;
        return false;
      } else if (!this.employedFrom) {
        this.fire('oe-show-error', {
          message: getLabel('l_validateEmploymentDateErr')
        });
        this.$$("#employmentStartDate_selfEmployed").invalid = true;
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  } //update the empoyer details


  _updateEmployerDetails() {
    if (this._validateEmployerDetailsForm()) {
      if (this.$$("#jobType") != null) {
        this.$$("#jobType").invalid = false;
      }
      if (this.$$("#empNameInp") != null) {
        this.$$("#empNameInp").invalid = false;
      }

      if (this.$$("#empPosition") != null) {
        this.$$("#empPosition").invalid = false;
      }

      if (this.$$("#employmentStDate") != null) {
        this.$$("#employmentStDate").invalid = false;
      }

      if (this.$$('#empPosition_military') != null) {
        this.$$('#empPosition_military').invalid = false;
      }
      if (this.$$('#employmentStartDate_military') != null) {
        this.$$('#employmentStartDate_military').invalid = false;
      }
      if (this.$$('#businessName') != null) {
        this.$$('#businessName').invalid = false;
      }
      if (this.$$('#employmentStartDate_selfEmployed') != null) {
        this.$$('#employmentStartDate_selfEmployed').invalid = false;
      }
      if (this.authMethods == undefined || this.authMethods && this.authMethods.length == 0) {
        this.authMethods = [];
        this.header = [];
      }

      var ajaxCall = document.createElement('oe-ajax');
      ajaxCall.contentType = "application/json";
      ajaxCall.handleAs = "json";
      ajaxCall.url = '/api/CBUsers/' + clientStorage.get(storageType.session, 'userId') + '/employer-details';
      ajaxCall.method = 'POST'; // create ajax body accordia to employment status

      if (this.selfEmployedStatusList.indexOf(this.employmentType) != -1) {
        ajaxCall.body = {
          "id": this.employersDetails.id ? this.employersDetails.id : "",
          "natureOfEmployment": this.employmentType ? this.employmentType : '',
          "businessName": this.businessName ? this.businessName : '',
          "emplStartDate": setBusinessDateString(this.employedFrom)
        };
      } else if (this.salariedStatusList.indexOf(this.employmentType) != -1) {
        ajaxCall.body = {
          "id": this.employersDetails.id ? this.employersDetails.id : "",
          "employmentStatus": this.jobType ? this.jobType : '',
          "natureOfEmployment": this.employmentType ? this.employmentType : '',
          "occupationType": this.occupationType ? this.occupationType : '',
          "employerName": this.employerCode ? this.employerCode : '',
          "emplStartDate": setBusinessDateString(this.employedFrom)
        };
      } else if (this.militaryEmployedList.indexOf(this.employmentType) != -1) {
        ajaxCall.body = {
          "id": this.employersDetails.id ? this.employersDetails.id : "",
          "natureOfEmployment": this.employmentType ? this.employmentType : '',
          "occupationType": this.occupationType ? this.occupationType : '',
          "emplStartDate": setBusinessDateString(this.employedFrom)

        };
      } else {
        ajaxCall.body = {
          "id": this.employersDetails.id ? this.employersDetails.id : "",
          "natureOfEmployment": this.employmentType ? this.employmentType : ''
        };
      }

      oeAjaxEventListner(ajaxCall);
      this.submitDetails(ajaxCall.url, ajaxCall.method, ajaxCall.body, this.header);
    }
  } //To open auth page to enter Txn password


  _callAuthPage() {
    this.$.employerDetailsUpdateAuthorization.$$("#employerDetailsUpdateAuthorization").open();
  } //To display success toast


  _callSucessPage(e) {
    this.$.employerDetailsUpdateAuthorization.$$("#employerDetailsUpdateAuthorization").close();
    this.resteFormValues();
    this.myprofilepagenumber = 0;

     // Fix for defect 396776
     var requestCode = e.detail.response.requestStatus.cmCode;
     if (requestCode == "WFR") {
       this.fire('oe-show-success', getLabel('l_employerUpdationPendingRMApproval'));
     }
     else if (requestCode == "SUC") {
       this.fire('oe-show-success', getLabel('l_employerDetailsUpdatedSuccessfully'));
       this.updateEmployFlag = true;
     }
     else if (requestCode == "PEN" || requestCode == "SUB" || requestCode == "SUS") {
       this.fire('oe-show-success', getLabel('m_RequestSubmittedSuccessfullyForReferenceId') + (e.detail.response.requestRefNo ? e.detail.response.requestRefNo : ""));
     }
     else if (requestCode == "ENT") {
       this.fire('oe-show-success', getLabel('m_RequestSucSubmitApproval') + (e.detail.response.requestRefNo ? e.detail.response.requestRefNo : ""));
     }
     else if (requestCode == "PFC") {
       this.fire('oe-show-success', getLabel('m_RequestSucSubmitPending') + (e.detail.response.requestRefNo ? e.detail.response.requestRefNo : ""));
     }
     else if (requestCode == "FAL") {
       this.fire('oe-show-error', getLabel('l_employerDetailsUpdateFail'));
     }
    this.authMethods = [];
  }
  /**Method that gets called during error condition from API -under defect 416910*/
  _errorHandler() {
    this.authMethods = [];
    this.$.employerDetailsUpdateAuthorization.$$("#employerDetailsUpdateAuthorization").close();
  }
  //To set the auth methods

  _continueToConfirm() {
    if (this.authenticationValidation(this.authMethods)) return;
    if (this.authMethods && this.authMethods.length == 1) this.header.primaryAccessCode = this.authMethods[0].wrapperValue;

    if (this.authMethods && this.authMethods.length == 2) {
      this.header.primaryAccessCode = this.authMethods[0].wrapperValue;
      this.header.secondaryAccessCode = this.authMethods[1].wrapperValue;
    }

    this._updateEmployerDetails();
  }

  //Manually  Focused on Header
  _focusOnTitle() {
    if (this.phone && $('.mainContent') !== undefined) {
      $('.mainContent')[0].style.marginBottom = "0px";
      $('#index_HeaderPanel')[0].children[1].style.marginTop = "8px";
      $('#index_HeaderPanel')[0].children[1].classList.remove('page-container-min-height');
  }
    setTimeout(function () {
      this.$$("#employer_details_title").setAttribute("tabindex", "0");
      this.$$("#employer_details_title").focus();
    }.bind(this), 0);
  }
  setFocus(event) {
    if (!event.shiftKey && (event.keyCode === 9 || KeyboardEvent.charCode == 9 || KeyboardEvent.keyCode == 9 || event.which == 9)) {
      this.shadowRoot.querySelector("#employer_details_title").focus();
    }
  }
  employerNameResponse(e){
    var response= e.detail.response;
    this.set("employerNameList", response);
    
  }
  getEmployerNameList(){
    var self= this;
    if (self.employersDetails.operationMode == "UPDATE") {
      if (self.employersDetails && self.employersDetails.hasOwnProperty('employerName')) {
        var employerNameStatusCode = [];
        employerNameStatusCode = self.employerNameList.filter(employee => {
          return employee.cmCode == self.employersDetails.employerName.cmCode;
        });

        if (employerNameStatusCode.length) {
          self.set("employerCode", employerNameStatusCode[0].cmCode);
        } //end of employmentStatus

      }
    } else {
      this.employerCode = "";
    }

  }
  _isSalaried(empStatus) {
    if (empStatus) {
      let empStat = empStatus.cmCode ? empStatus.cmCode : empStatus;
      if (this.salariedEmployeedList.includes(String(empStat).toUpperCase())) {
        this._clearSalariedEmploymentFields();
        this._clearMilitaryFields();
        this._clearSelfEmploymentFields();
        return true;
      }
    }
    this._clearSalariedEmploymentFields();
    return false;
  }
  _isSelfEmployed(empStatus) {
    if (empStatus) {
      let empStat = empStatus.cmCode ? empStatus.cmCode : empStatus;

      if (this.selfEmployeedList.includes(String(empStat).toUpperCase())) {
        this._clearSalariedEmploymentFields();
        this._clearMilitaryFields();
        this._clearSelfEmploymentFields();
        return true;
      }
    }
    this._clearSelfEmploymentFields();
    return false;
  }
  _isMilitary(empStatus) {
    if (empStatus) {
      let empStat = empStatus.cmCode ? empStatus.cmCode : empStatus;
      if (this.militaryEmployedList.includes(String(empStat).toUpperCase())) {
        this._clearMilitaryFields();
        this._clearSalariedEmploymentFields();
        this._clearSelfEmploymentFields();
        return true;
      }
    }
    this._clearMilitaryFields();
    return false;
  }

} // Associate the new class with an element name


customElements.define('employer-details', employerDetails);